// 9fbef606107a605d69c0edbcd8029e5d
import { USER_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const USER_CONSTANTS = {
  SET_USER_INFO: `${USER_ACTION_PATTERN}SET_USER_INFO`,
  GET_USER_INFO: `${USER_ACTION_PATTERN}GET_USER_INFO`,
  SET_CHILDREN: `${USER_ACTION_PATTERN}SET_CHILDREN`,
  RESET_USER_INFO: `${USER_ACTION_PATTERN}RESET_USER_INFO`,
  SET_IS_FETCHING: `${USER_ACTION_PATTERN}SET_IS_FETCHING`,
  CLEAR_USER_INFO_TTL: `${USER_ACTION_PATTERN}CLEAR_USER_INFO_TTL`,
  GET_USER_INFO_TTL: 10 * 60 * 1000,
  SET_SURVEY_QUESTIONS: 'SET_SURVEY_QUESTIONS',
  SET_SURVEY_ANSWERS: `${USER_ACTION_PATTERN}SET_SURVEY_ANSWERS`,
  SET_GEO_COORDINATES: `${USER_ACTION_PATTERN}SET_GEO_COORDINATES`,
  SET_FAVORITE_STORE: `${USER_ACTION_PATTERN}SET_FAVORITE_STORE`,
  SET_DEFAULT_STORE: `${USER_ACTION_PATTERN}SET_DEFAULT_STORE`,
  RESPONSE_PLCC_CARD_ID_INFORMATION: 'RESPONSE_PLCC_CARD_ID_INFORMATION',
  RESPONSE_SET_PLCC_INFORMATION: 'RESPONSE_SET_PLCC_INFORMATION',
  SET_IS_EXPRESS_ELIGIBLE: `${USER_ACTION_PATTERN}SET_IS_EXPRESS_ELIGIBLE`,
  SET_IS_REGISTERED_USER_CALL_DONE: `${USER_ACTION_PATTERN}SET_IS_REGISTERED_USER_CALL_DONE`,
  GENERIC_USER_ID: '-1002',
  SET_USER_NEAR_DATA: 'SET_USER_NEAR_DATA',
  EMAIL_CONFIRMATION: 'email-confirmation',
  REGISTRATION_TYPE: '10',
  SET_LOGIN_IN_PROCESS_STATE: 'SET_LOGIN_IN_PROCESS_STATE',
  SET_BRAND_TOGGLE_IN_PROGRESS: 'SET_BRAND_TOGGLE_IN_PROGRESS',
};

export default USER_CONSTANTS;
